export default function getFirstCharacter (string: string) {
  const codePoint = string.codePointAt(0)
  if (codePoint === undefined) return
  return String.fromCodePoint(codePoint)
}
